import { cellStyle } from 'appConstants';

// Default Email-mode starter content: Heading + Text + Footer. The footer ships an unsubscribe
// link (`{$unsubscribeLink}`) BY CONSTRUCTION, so an email authored in Email mode always has one
// (deliverability — see DND_BUILDER_UNSUBSCRIBE_AND_TOKENS.md). Used to seed a new/cleared Email
// canvas (see Grapes.js handleClearCanvas). See DND_EMAIL_MODE_SPEC.md §7.
//
// Rows mirror Blocks/Email/blocks.js: an `email-row` <table> (selectable → row toolbar) with a
// LOCKED inner scaffold and edit-in-place content.

const LOCK =
  'data-gjs-selectable="false" data-gjs-hoverable="false" data-gjs-editable="false" data-gjs-droppable="false"';

// Email-safe row style: no fixed height (the shared `tableStyle` bakes in 150px, meant for empty
// Advanced-mode placeholders, which made the default email three tall empty rows).
const ROW_STYLE = 'width:100%;border-collapse:collapse;';

const row = (content) => `
  <table data-gjs-type="email-row" data-type="section" role="presentation" width="100%" border="0" cellpadding="0" cellspacing="0" style="${ROW_STYLE}">
    <tbody ${LOCK}>
      <tr ${LOCK}>
        <td ${LOCK} style="${cellStyle} width: 100%;">${content}</td>
      </tr>
    </tbody>
  </table>`;

// Content is edit-in-place but not draggable (a beginner moves whole rows, never sub-elements).
const LOCK_DRAG = 'data-gjs-draggable="false"';
const H1 = `${LOCK_DRAG} style="font-family: Arial, sans-serif; font-size: 24px; line-height: 1.3; color: #111; margin: 0 0 8px;"`;
const TEXT = `${LOCK_DRAG} style="font-family: Arial, sans-serif; font-size: 15px; line-height: 1.5; color: #333;"`;
const FOOTER = `${LOCK_DRAG} style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.5; color: #888888; text-align: center;"`;

export const emailScaffold =
  row(`<h1 ${H1}>Your heading</h1>`) +
  row(`<p ${TEXT}>Write your message here. Double-click to edit.</p>`) +
  row(
    `<p ${FOOTER}>You received this email because you subscribed to our list.<br/>` +
      `<a href="{$unsubscribeLink}" style="color: #888888; text-decoration: underline;">Unsubscribe</a></p>`,
  );
